<template>
	<div v-if="items.length || itemsIneligible.length" class="card-v2 card-jobs-offered-me">
		<header class="margin">
			<h2>Job Offers Awaiting Response</h2>
		</header>

		<div class="grid gap-16">
			<ItemOfferedJob
				v-for="job in items"
				:key="`offered-job-${job.id}`"
				:job="job"
			/>
			<ItemOfferedJob
				v-for="(item, index) in itemsIneligible"
				:key="`offered-job-ineligible-${index}`"
				:job="item.job"
				:is-canceled="item.log.resourceCase == 'canceledJob'"
				:is-expired="item.log.resourceCase == 'expiredJob'"
				:expired-free-job="item.log.resourseCaseDescription == 'expiredJobButStillHasFreeJobChance' && item.log.resourceCase == 'expiredJob'"
				:candidate-prop="item.candidate"
			/>
		</div>
		
		<DeclineJobModal />
		<AcceptTrialJobModal/>
	</div>
</template>

<script>
import DeclineJobModal from '@/components/jobs/DeclineJobModal';
import AcceptTrialJobModal from '@/components/jobs/AcceptTrialJobModal';
import ItemOfferedJob from '@/components/dashboard/ItemOfferedJob';
import { fetchJobsOfferedMe, fetchJobsOfferedMeIneligible } from '@/services/swm/api';

export default {
	name: 'CardJobsOfferedMe',
	components: {
		ItemOfferedJob,
		DeclineJobModal,
		AcceptTrialJobModal,
	},
	methods: {
		async fetchData() {
			try {
				const jobs = await fetchJobsOfferedMe();
				this.items = jobs;
			} catch (error) {
				console.log('%% fetchJobsOfferedMe error', error);
			}

			// Expired + canceled offers
			try {
				const jobs = await fetchJobsOfferedMeIneligible();
				this.itemsIneligible = jobs;
			} catch (error) {
				console.log('%% fetchJobsOfferedMeIneligible error', error);
			}
		},
	},
	computed: {
		items: {
			get() {
				return this.$store.getters['cache/dashboardJobsOfferedMe'];
			},
			set(items) {
				return this.$store.commit('cache/setCache', {
					name: 'dashboardJobsOfferedMe',
					items
				});
			},
		},
		itemsIneligible: {
			get() {
				return this.$store.getters['cache/dashboardJobsOfferedMeIneligible'];
			},
			set(items) {
				return this.$store.commit('cache/setCache', {
					name: 'dashboardJobsOfferedMeIneligible',
					items
				});
			},
		},
	},
	created() {
		this.$store.dispatch('subscriptions/getMySubscription');
		this.fetchData();
	},
}
</script>
